const EVNStyles = {
  // page layout
  fileContent: {
    position: 'relative',
    height: 'calc(100vh - 75px)',
    padding: 2,
    boxSizing: 'border-box',
    backgroundColor: '#f0f0f0',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    gap: 2,
  },
};

export default EVNStyles;
